/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Schedule_StartInputs */

const vi_shop_home_schedule_start = /** @type {(inputs: Shop_Home_Schedule_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ`)
};

/**

* @param {Shop_Home_Schedule_StartInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_schedule_start = /** @type {((inputs?: Shop_Home_Schedule_StartInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Schedule_StartInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_schedule_start(inputs)
});